var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
/** Um colaborador, e o interruptor que diz se este profissional o acompanha. */
let AssignRowScope = class AssignRowScope extends Scope {
    constructor() {
        super(...arguments);
        this.name = '';
        this.cpf = '';
        this.assigned = false;
        /** Enquanto o servidor nao respondeu - o interruptor fica surdo, e nao mente. */
        this.busy = false;
        this.onToggle = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], AssignRowScope.prototype, "name", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], AssignRowScope.prototype, "cpf", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], AssignRowScope.prototype, "assigned", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], AssignRowScope.prototype, "busy", void 0);
AssignRowScope = __decorate([
    Observable
], AssignRowScope);
export { AssignRowScope };
/** Uma profissao na lista do formulario. */
let ProfessionalTypeScope = class ProfessionalTypeScope extends Scope {
    constructor() {
        super(...arguments);
        this.label = '';
        this.value = '';
        this.current = false;
        this.onSelect = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], ProfessionalTypeScope.prototype, "label", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ProfessionalTypeScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], ProfessionalTypeScope.prototype, "current", void 0);
ProfessionalTypeScope = __decorate([
    Observable
], ProfessionalTypeScope);
export { ProfessionalTypeScope };
/**
 * A ficha de um usuario da empresa: tudo o que da para configurar nele.
 *
 * O que NAO esta aqui, e e decisao: **e-mail** (e a chave de login, e troca-lo em
 * outra pessoa e tomar a conta dela), **papeis** (mudar quem e administrador pela
 * tela e promocao silenciosa) e **senha** (ninguem escolhe a de outro - o caminho e
 * o e-mail).
 */
let CompanyUserDetailScope = class CompanyUserDetailScope extends Scope {
    constructor() {
        super(...arguments);
        this.loading = true;
        /** O rotulo do botao de voltar, que nomeia a lista de onde se veio. */
        this.backLabel = 'Acesso ao painel';
        // :: identidade, so para ler
        this.name = '';
        this.email = '';
        this.papel = '';
        this.active = true;
        this.profissional = false;
        // :: dados de pessoa
        this.firstName = '';
        this.lastName = '';
        this.socialName = '';
        this.phone = '';
        /** O CPF viaja por endpoint proprio - ele carrega checagem de unicidade. */
        this.cpf = '';
        /** Se o CPF foi FABRICADO a partir do CNPJ, no cadastro da empresa. */
        this.cpfFicticio = false;
        this.saving = false;
        /** Se ha algo por salvar - e o que liga o botao. */
        this.dirty = false;
        // :: registro de conselho, so em quem e profissional
        this.showRegistration = false;
        this.typeSummary = '';
        this.types = [];
        /**
         * As ESPECIALIDADES da profissao escolhida, e a escolhida entre elas.
         *
         * Vazio quando a profissao nao tem especialidade - personal trainer e fisiologista
         * nao tem - e o segundo seletor nem aparece.
         */
        this.specialtySummary = '';
        this.specialties = [];
        this.registrationNumber = '';
        this.uf = '';
        /** Se o conselho escolhido e regulamentado - ver `ProfessionalType.regulated`. */
        this.regulated = false;
        // :: colaboradores acompanhados, so em quem e profissional
        this.showAssignment = false;
        this.assignLoading = true;
        this.term = '';
        this.rows = [];
        this.assignedCount = 0;
        this.total = 0;
        // :: acoes sobre a conta
        /**
         * Desativar nao e desligar.
         *
         * Desligado sai do quadro da empresa e perde os vinculos; desativado continua no
         * quadro e apenas nao entra. Quem sai de licenca e o segundo caso, e por isso as
         * duas acoes convivem.
         */
        this.accountBusy = false;
        // :: o master da empresa (B-30)
        /** Esta pessoa e o administrador master da empresa. */
        this.master = false;
        /**
         * Se quem esta logado pode desativar e desligar esta pessoa. Sem isso as duas acoes
         * saem da ficha, e no lugar fica a frase que diz por que.
         */
        this.podeAlterarAcesso = false;
        /** Se quem esta logado pode passar a condicao de master a esta pessoa. */
        this.podeTornarMaster = false;
        /** Por que as acoes de acesso nao estao ali - vazio quando estao. */
        this.motivoSemAcesso = '';
        this.onMakeMaster = Scope.ASYNC_ACTION;
        this.onFirstNameChanged = Scope.SYNC_ACTION_STRING;
        this.onLastNameChanged = Scope.SYNC_ACTION_STRING;
        this.onSocialNameChanged = Scope.SYNC_ACTION_STRING;
        this.onPhoneChanged = Scope.SYNC_ACTION_STRING;
        this.onCpfChanged = Scope.SYNC_ACTION_STRING;
        this.onRegistrationChanged = Scope.SYNC_ACTION_STRING;
        this.onUfChanged = Scope.SYNC_ACTION_STRING;
        this.onClearType = Scope.ASYNC_ACTION;
        /** Desfaz so a especialidade, mantendo a profissao. */
        this.onClearSpecialty = Scope.ASYNC_ACTION;
        this.onTermChanged = Scope.SYNC_ACTION_STRING;
        this.onSave = Scope.ASYNC_ACTION;
        this.onToggleActive = Scope.ASYNC_ACTION;
        this.onRemove = Scope.ASYNC_ACTION;
        this.onBack = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "loading", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyUserDetailScope.prototype, "error", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "backLabel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "name", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "email", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "papel", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "active", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "profissional", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "firstName", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "lastName", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "socialName", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "phone", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyUserDetailScope.prototype, "firstNameError", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyUserDetailScope.prototype, "lastNameError", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyUserDetailScope.prototype, "phoneError", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "cpf", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyUserDetailScope.prototype, "cpfError", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "cpfFicticio", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "saving", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyUserDetailScope.prototype, "formError", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "dirty", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "showRegistration", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "typeSummary", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], CompanyUserDetailScope.prototype, "types", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "specialtySummary", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], CompanyUserDetailScope.prototype, "specialties", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "registrationNumber", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "uf", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "regulated", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "showAssignment", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "assignLoading", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], CompanyUserDetailScope.prototype, "assignError", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "term", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], CompanyUserDetailScope.prototype, "rows", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "assignedCount", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "total", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "accountBusy", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "master", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "podeAlterarAcesso", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "podeTornarMaster", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], CompanyUserDetailScope.prototype, "motivoSemAcesso", void 0);
CompanyUserDetailScope = __decorate([
    Observable
], CompanyUserDetailScope);
export { CompanyUserDetailScope };
//# sourceMappingURL=company-user-detail.scope.js.map